module.exports = __webpack_public_path__ + "static/media/matilde-cap-sri-lanka-scary.0f282ff5.png";